import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName } from '../../utils'
import { loadCity, loadCourses, loadJuries, loadTalents } from '../../utils/Network'
import { makeDarkSelectStyles } from '../selectStyles';

export default function SelectShowUserDocumentsOnly({ callback, value, width ,name="is_verified" }) {

    const customStyles = makeDarkSelectStyles({ width: width || '200px' });

    
    var options = [
        {
            label: "Only Items With Document",
            value: 1
        },
        {
            label : "All Items",
            value : 0
        }
    ]

    const handleSelect = (e) => {
        var value = e.value;
        callback(value, name)

    }

    return (
        <>
            <div className="filter-select">
                <Select options={options}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder="view talents with document"
                    value={options && options.filter(obj => obj.value == value)}


                />
            </div>
            
        </>
    )
}
